import { ActionReducerMap } from '@ngrx/store';

import { nodeSearchReducer } from './node-search.reducer';
import { nodeEditorModalReducer } from './nodes-editor-modal.reducer';
import { NodesEditorState } from './nodes-editor.state';

export const nodesEditorReducer: ActionReducerMap<NodesEditorState> = {
  nodeEditorModal: nodeEditorModalReducer,
  search: nodeSearchReducer,
};
